import { Checkbox } from "primereact/checkbox";

export type CheckboxColumnTemplateProps = {
  checked?: boolean;
  onChange: (checked: boolean) => void;
};

export const CheckboxColumnTemplate: React.FC<CheckboxColumnTemplateProps> = (
  props
) => (
  <div className="p-d-flex p-jc-center" style={{ width: "100%" }}>
    <Checkbox
      checked={props.checked}
      onChange={(e) => props.onChange(e.checked)}
    />
  </div>
);
